module.exports = __webpack_public_path__ + "static/media/capsules.bcff1511.svg";